module.exports = __webpack_public_path__ + "static/media/image1.d9b09bdb.jpg";